import { DataProxy } from '~/node_modules/apollo-cache/src/types/DataProxy'
import { getLocalCart, mutationLocalCart } from '~/graphql/gqlLocal/localCart'
import {
  mutationSuggestFragments,
  getSuggestFragmentsFromStorage,
} from '~/graphql/gqlLocal/localSuggestFragments'
import {
  mutationHeader,
  initialState as headerInitialState,
} from '~/graphql/gqlLocal/localHeader'
import { mutationLocalUi, uiInitialState } from '~/graphql/gqlLocal/localUi'
import { ApolloCtx } from '~/plugins/apolloConfig'

export const onCacheInit = (csrfToken: string | undefined | null) => (
  cache: DataProxy
) => {
  const suggestFragments = getSuggestFragmentsFromStorage()

  cache.writeData({
    data: {
      suggestFragments,
      ...headerInitialState,
      ...uiInitialState,
      csrfToken: csrfToken ?? null,
    },
  })
}

export const mutation = (ctx: ApolloCtx) => {
  return {
    ...mutationLocalCart(ctx),
    ...mutationSuggestFragments,
    ...mutationHeader,
    ...mutationLocalUi,
  }
}

export const ApolloQuery = (ctx: ApolloCtx) => {
  return {
    ...getLocalCart(ctx),
  }
}

export const typeDefs = `
  type AddToCartArg {
    openCart: Boolean
    variantId: Int!
    count: Int!
    wishListId: Int
    itemId: Int!
    itemsCount: Int!
  }
`
